import React from 'react';
import { useAuth } from '../context/AuthContext';

// Resolves one route to a department-specific screen.
//
//   <DeptPage it={TicketManager} bm={BmTicketManager} />
//
// A route with no `bm` variant falls back to the IT screen, so departments can
// diverge one page at a time instead of all at once. When BioMedical is
// extracted to its own server, src/pages/bm moves with it and the `it` props
// are all that remain here.
const DeptPage = ({ it: ItComponent, bm: BmComponent, ...rest }) => {
  const { user } = useAuth();

  const byDepartment = {
    IT: ItComponent,
    BM: BmComponent || ItComponent
  };

  const Component = byDepartment[user?.department_code] || ItComponent;
  if (!Component) return null;

  return <Component {...rest} />;
};

export default DeptPage;
